import { useField, useFormikContext, getIn } from "formik";
import { dissoc } from "ramda";

import { RadioGroup, RadioGroupProps } from "src/components/RadioGroup";

export interface FormikRadioGroupProps extends Omit<
  RadioGroupProps,
  "name" | "onChange"
> {
  /** Formik field name. */
  name: string;
  /** Callback fired when the value changes. Also supports onChange for compatibility. */
  onChange?: (value: string) => void;
}

const FormikRadioGroup = ({
  name,
  onValueChange: onValueChangeProp,
  onChange: onChangeProp,
  ...props
}: FormikRadioGroupProps) => {
  const [field, meta] = useField(name);
  const {
    setFieldValue,
    status = {},
    setStatus,
  } = useFormikContext<Record<string, unknown>>();
  const fieldStatus = getIn(status, name);

  return (
    <RadioGroup
      error={meta.touched ? meta.error || fieldStatus : ""}
      name={field.name}
      value={field.value}
      onValueChange={(value: string) => {
        setStatus(dissoc(name, status));
        setFieldValue(name, value);
        onValueChangeProp?.(value);
        onChangeProp?.(value);
      }}
      {...props}
    />
  );
};

FormikRadioGroup.displayName = "FormikRadioGroup";
FormikRadioGroup.Item = RadioGroup.Item;

export { FormikRadioGroup };
